import * as angular from 'angular';

export class ReportSupervisorController {
    static $inject = ['$translate'];
    constructor(private $translate: angular.translate.ITranslateService) { }
}

angular.module('naut')
    .component('reportSupervisor', {
        template: require('./reportSupervisor.html'),
        controller: ReportSupervisorController,
        controllerAs: 'ctrl'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/account/components/reportSupervisor/reportSupervisor.component.ts